var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text.length)?_c('div',[_c('a-button',{style:({ margin: '8px 0' }),attrs:{"type":"primary","icon":_vm.icon},on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.text))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }